import { cutHostName } from "@/libs/utils";
export { default as validate } from "./validate.js";

export const CDN_URL = "//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform";
export const CDN_URL_1 = "//static.hzwxbz3.cn/Lianyun/font_end/wxhd"
export const IS_LOCAL = process.env.NODE_ENV !== 'production';

export const IS_YW = window.location.hostname.includes("yw-") || window.location.hostname.includes("yuwanc.com") || window.location.hostname.includes("w2you.com") || window.location.hostname.includes("bgyxy.com");

export const IS_PRE = window.location.hostname.includes("-pre");

// sdk红包相关配置 - 悦玩用「悦玩」公众号，玩心沿用原有公众号「变态喵推荐」
export const SDKHB_APP_ID = IS_YW ? "wxa669b5d72084f88e" : "wx4e30ec1302cc8709";

// sdk红包绑定码页 - 悦玩用「悦玩」公众号，玩心沿用原有公众号
export const SDKHB_CODE_BIND_APP_ID = IS_YW ? "wxa669b5d72084f88e" : "wx6e5c2167466c6764";

// sdk红包 wxLogin/wxRole 链路 - 悦玩用「悦玩」公众号，玩心沿用原有公众号
export const SDKHB_WX_APP_ID = IS_YW ? "wxa669b5d72084f88e" : "wx02a11d85d79282b2";

const getEnv = function() {
  // 手游接口没有测试环境
  const pathname = cutHostName(window.location.pathname);
  const name = window.location.hostname + pathname;
  
  if (IS_LOCAL) {
    switch (pathname) {
      case '/heziShare':
        return "//btboxtest.hzwxbz999.cn";
      // 快手表单活动
      case '/ksForm':
        return "//platform-cloud-test.hzwxbz999.cn";
      case '/box':
        // 如果页面在此路径下，需根据接口情况 决定在本地使用什么域名
        // return "//172.16.28.40:10062" // 10063
        // return "//btboxtest.hzwxbz999.cn";
        return "https://wxhdtest.hzwxbz999.cn";
    }
  }

  // 悦玩域名按路径分流，避免新增域名（如预发 wxhd-pre.yuwanc.com）落到玩心默认地址
  if (IS_YW) {
    const YW_HOST = IS_PRE ? "//h5-pre.yuwanc.com" : "//h5.yuwanc.com";
    switch (pathname) {
      case "/packet":
        return `${YW_HOST}/redPackets`;
      case "/sdkhb":
        return `${YW_HOST}/sdkPackets`;
      case "/gameJump":
        return `${YW_HOST}/wechat`;
      case "/recall":
        return YW_HOST;
    }
  }

  switch (name) {
    // 盒子分享
    case "wxhdtest.hzwxbz999.cn/heziShare":
    case "wxhdtest.hzwxbz999.cn/box":
      return "//btboxtest.hzwxbz999.cn";
    // 预发未修改 & 线上未配置
    case "wxhdpre.hzwxbz999.cn/heziShare":
    case "wxhdpre.hzwxbz999.cn/box":
      return "//btboxpre.hzwxbz999.cn";
    case "wxhd.hzwxbz2.cn/box":
    case "wxhd.hzwxbz2.cn/heziShare":
    case "btmao.wxbz111.cn/heziShare":
    case "btmao1.wxbz111.cn/heziShare":
    case "btmao2.wxbz111.cn/heziShare":
    case "btmao3.wxbz111.cn/heziShare":
    case "btmao4.wxbz111.cn/heziShare":
      return "//bthezi.hzwxbz3.cn";
    // 直播红包
    case "wxhdpre.hzwxbz999.cn/packet":
      return "//h5.680game.cn/redPackets";
    case "wxhdtest.hzwxbz999.cn/packet":
      return "//h5.680game.cn/redPackets";
    case "wxhd.hzwxbz2.cn/packet":
      return "//h5.hzwxbz3.cn/redPackets";
    // sdk红包
    case "wxhdpre.hzwxbz999.cn/sdkhb":
      return "//h5.hzwxbz999.cn/sdkPackets";
    case "wxhdtest.hzwxbz999.cn/sdkhb":
      return "//h5.hzwxbz999.cn/sdkPackets";
    case "wxhd.hzwxbz2.cn/sdkhb":
      return "//h5.hzwxbz3.cn/sdkPackets";
    // 快手红包
    case "wxhd.hzwxbz2.cn/kshb":
      return "//h5.hzwxbz3.cn/ks";
    // case "wxhd.hzwxbz2.cn/kshb":
    //   return "//h5.70games.cn/ks";
    // 小程序跳转
    case "wxhd.hzwxbz2.cn/gameJump":
      return "//h5.hzwxbz3.cn/wechat";
    case "172.16.31.253:8021/gameJump":
    case "wxhdtest.hzwxbz999.cn/gameJump":
      return "//h5test.hzwxbz999.cn/wechat";
    case "wxhdpre.hzwxbz999.cn/gameJump":
      return "//h5.hzwxbz999.cn/wechat";
    // 召回活动
    case "wxhdpre.hzwxbz999.cn/recall":
      return "//h5.70games.cn";
    case "wxhdtest.hzwxbz999.cn/recall":
      return "//h5.52ywan.cn";
    case "wxhd.hzwxbz2.cn/recall":
      return "https://h5.hzwxbz3.cn";
    case "wxhd.joyyouxi.com/recall":
    case "wxhd.440youxi.com/recall":
    case "wxhd.yuwanf.com/recall":
    case "wxhd.sogame8.cn/recall":
    case "wxhd.aiotgames.cn/recall":
    case "wxhd.chy1.cn/recall":
    case "wxhd.989youxi.com/recall":
      return "https://h5.hzwxbz3.cn";
    // 快手表单活动礼包
    case "wxhdtest.hzwxbz999.cn/ksForm":
      return "//platform-cloud-test.hzwxbz999.cn";
    case "wxhdpre.hzwxbz999.cn/ksForm":
      return "//platform-cloud-pre.hzwxbz999.cn";
    case "wxhd.hzwxbz2.cn/ksForm":
      return "//platform-cloud.hzwxbz2.cn";
    default:
      return "//h5.hzwxbz3.cn/redPackets";
  }
};

// 本地测试环境服务器域名
const testEnv = function() {
  const pathname = cutHostName(window.location.pathname);
  switch (pathname) {
    case "/packet":
      return "//h5.680game.cn/redPackets";
    case "/sdkhb":
      return "//h5.680game.cn/sdkPackets";
    case "/recall":
      // return "//172.16.61.158:8082";
      return "//h5.52ywan.cn";
  }
};

// 本地测试环境服务器域名
const WX_APP_ID_FUNC = function() {
  const pathname = cutHostName(window.location.pathname);
  switch (pathname) {
    case "/packet":
      return "wx4e30ec1302cc8709";
    case "/sdkhb":
      return SDKHB_APP_ID;
    case "/kshb":
      return "wx4e30ec1302cc8709";
  }
};

// 通用服务端地址
export const API_URL = getEnv();

// 获取微信信息服务端地址
export const WX_URL = "//system.hzyuewan.com";
// export const WX_URL = "//system.hzwxbz2.cn";

// 微信活动相关配置 - 公众号：变态喵推荐
export const PACKET_APP_ID = "wx4e30ec1302cc8709";

// 快手红包相关配置 - 公众号：变态喵推荐
export const KUAISHOU_APP_ID = "wx4e30ec1302cc8709";

// 小程序转移相关配置 - 公众号：武道将魂
export const GAMEJUMP_APP_ID = "wxb9a839327a5b4f9c";

export const WX_APP_ID = WX_APP_ID_FUNC();
